import { Box } from '@mui/material';
import MuiAccordion from '@mui/material/Accordion';
import { FC } from 'react';

import { AbgTypography } from '@abg/kit-base';
import { usePageContext } from '@abg/web-core/context/page/client-provider';

import { useTranslationContext } from '../../../../shared/context';
import { AncillariesI18nKeys } from '../../../../shared/types';
import {
  CustomMuiAccordionClass,
  MuiAccordionElevation,
  PANELS,
} from '../../car-info-accordion.constants';
import { CarInfoDetails } from '../CarInfoDetails';
import { CarInfoSummary } from '../CarInfoSummary';
import { RateTermsSummary } from '../RateTerms';

import { RateTermsAccordionProps } from './rate-terms-accordion.types';
import {
  accordionStyling,
  RateTermsLabelStyling,
  RateTermsStyling,
  RateTermsSummaryStyling,
} from './RateTermsAccordion.styling';

export const RateTermsAccordion: FC<RateTermsAccordionProps> = ({
  onChange,
  activeSummary,
  rateTerms,
  unpricedExtrasNotes,
  currency = 'USD',
  isPayNowChecked,
}) => {
  const pageContext = usePageContext();
  const isEmea = pageContext?.region === 'emea';
  const { t, i18nKeys } = useTranslationContext<AncillariesI18nKeys>();

  return (
    <>
      {unpricedExtrasNotes && unpricedExtrasNotes !== '' && (
        <AbgTypography
          variant="actionSmallRegular"
          component="div"
          data-testid="unpriced-extras-notes"
          sx={RateTermsLabelStyling}
        >
          {unpricedExtrasNotes}
        </AbgTypography>
      )}

      {!isEmea && (
        <MuiAccordion
          sx={accordionStyling}
          className={CustomMuiAccordionClass}
          disableGutters
          elevation={MuiAccordionElevation}
          square
          onChange={onChange(PANELS.FIFTH)}
          data-testid="rate-terms-accordion"
        >
          <CarInfoSummary
            hasExpandIcon={false}
            activeSummary={activeSummary[PANELS.FIFTH]}
          >
            <AbgTypography
              variant="actionSmallRegular"
              data-testid="rate-terms-label"
              sx={RateTermsStyling}
            >
              {t(i18nKeys.rateTermsLabel)}
            </AbgTypography>
          </CarInfoSummary>

          <CarInfoDetails>
            <Box sx={RateTermsSummaryStyling}>
              <RateTermsSummary rateTerms={rateTerms} currency={currency} isPayNowChecked={isPayNowChecked} />
            </Box>
          </CarInfoDetails>
        </MuiAccordion>
      )}
    </>
  );
};
